var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"area-message"},[_c('h5',[_vm._v("Групповой чат")]),_c('messages',{attrs:{"group_id":_vm.group_id}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }